import { useState, useEffect } from 'react';

export const useMobile = (matchMedia?: string) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isHydrated, setIsHydrated] = useState<boolean>(false);

  useEffect(() => {
    setIsHydrated(true);
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia(matchMedia || '(max-width: 767px)');

      const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

      setIsMobile(mediaQuery.matches);
      mediaQuery.addEventListener('change', handleChange);

      return () => mediaQuery.removeEventListener('change', handleChange);
    }
  }, [matchMedia]);

  return isHydrated ? isMobile : false;
};
